import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { APIService, ModuleType } from '../../API.service';
import * as pluralize from 'pluralize'
import { copyToClipboard, sortByLabel, sortByOrder } from '../../app.utilities';
import { environment } from 'src/environments/environment';
import { Location } from '@angular/common';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { AuthenticatorService } from '@aws-amplify/ui-angular';
import { CurrentUserService } from 'src/app/services/current-user.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomeComponent implements OnInit {

  private institution: {
    id: string,
    navigationNodeLevelNames: Array<string>
  };

  parentId: string;

  navigationNodeId: string;

  navigationNodes: Array<{
    id: string,
    label: string,
    description: string,
    image: string,
    order: number
  }> = []
  modules: Array<{
    id: string,
    label: string,
    description: string,
    image: string,
    completed: boolean,
    order: number,
    type: ModuleType
  }> = []

  loading: boolean = true;
  loadingModules: boolean = false;
  loadingNavigationNodes: boolean = false;
  levelName: Array<string> = ["", ""];

  ModuleType = ModuleType;

  nodeSortablejsOptions = {
    onUpdate: (event: any) => {
      this.onNodeSortChange(event)
    }
  }

  moduleSortablejsOptions = {
    onUpdate: (event: any) => {
      this.onModuleSortChange(event)
    }
  }

  breadcrumb: Array<{
    id: string,
    label: string,
    link: boolean
  }> = [];

  authSub: Subscription = null;
  routeSub: Subscription = null;

  constructor(
    private api: APIService, 
    private activatedRoute: ActivatedRoute, 
    private router: Router, 
    private location: Location, 
    private _snackbar: MatSnackBar,
    private authenticator: AuthenticatorService,
    public currentUser: CurrentUserService) {}

  ngOnInit(): void {

    this.routeSub = this.activatedRoute.params.subscribe(async (params) => {
      this.navigationNodeId = params['parent'] || null;
      this.reload();
    }) 

  }

  reload() : void {

    this.loading = true;
    this.loadingModules = false;
    this.loadingNavigationNodes = false;
    this.breadcrumb = [];
    this.modules = [];
    this.navigationNodes = []

    var institutionId = this.authenticator.user.attributes['custom:institution_id']
    var userId = this.authenticator.user.attributes.sub
    
    if (this.navigationNodeId) {
      this.loadNavigationNode(userId)
    } else {
      this.loadRootNodes(institutionId, userId)
    }

  }

  loadNavigationNode(userId) : void {

    this.api.getNavigationNodeForUser(this.navigationNodeId, userId).then(async (value) => {

      this.institution = {
        id: value.institution.id,
        navigationNodeLevelNames: value.institution.navigationNodeLevelNames
      }

      var levelName = this.institution.navigationNodeLevelNames[1];

      this.levelName = [levelName, pluralize(levelName)]

      this.breadcrumb.push({
        id: value.id,
        label: value.label,
        link: false
      })

      var nnc = value.institution.navigationNodeConnections.items.filter((nnc) => nnc.id == this.navigationNodeId)[0]

      while (nnc) {   
        var node = value.institution.navigationNodes.items.filter((nn) => nn.id == nnc.parentId)[0]
        this.breadcrumb.splice(0, 0, {
          id: node.id,
          label: node.label,
          link: true
        });
        nnc = value.institution.navigationNodeConnections.items.filter((nnc) => nnc.id == node.id)[0]
      }
    
      this.breadcrumb.splice(0, 0, {
        id: '',
        label: pluralize(this.institution.navigationNodeLevelNames[0]),
        link: true
      })
        
      value.childConnections.items.forEach(cc => {

        if (cc.child.active && (this.currentUser.isPresenter || cc.child.visible == null || cc.child.visible)) {

          var childNodeCount = cc.child.childConnections.items.filter(cc => cc.child.active && (this.currentUser.isPresenter || cc.child.visible == null || cc.child.visible)).length 
          var childModuleCount = cc.child.modules.items.filter(m => this.currentUser.isPresenter || m.visible == null || m.visible).length

          var navigationNode = {
            id: cc.child.id,
            description: cc.child.description,
            image: cc.child.image ? environment.cloudfrontUrl + cc.child.image : null,
            label: cc.child.label,
            order: cc.order,
            childCount: childNodeCount + childModuleCount,
            visible: cc.child.visible == null || cc.child.visible
          }

          this.navigationNodes.push(navigationNode)

        }

      })

      this.sortNavigationNodesByOrder();

      value.modules.items.forEach(async m => {

        if (m.active && (this.currentUser.isPresenter || m.visible == null || m.visible)) {

          var completed = false;
          if (m.runs.items.length != 0){
            completed = m.questions.items.length == m.runs.items[0].responses.items.length;
          }

          var module = {
            id: m.id,
            label: m.label,
            image: m.image ? environment.cloudfrontUrl + m.image : null,
            description: m.description,
            order: m.order,
            completed: completed,
            visible: m.visible == null || m.visible,
            public: m.public === true,
            type: m.type
          }

          this.modules.push(module)

        }
      
      })

      this.sortModulesByOrder();

      this.loading = false;

    })

  }

  loadRootNodes(institutionId, userId) : void {

    this.api.GetInstitutionWithNodes(institutionId, userId).then(async institution => {

      this.institution = {
        id: institution.id,
        navigationNodeLevelNames: institution.navigationNodeLevelNames
      };

      var levelName = this.institution.navigationNodeLevelNames[0];

      this.levelName = [levelName, pluralize(levelName)]
      
      if (!this.currentUser.isPresenter) {
        this.breadcrumb.push({
          id: '',
          label: pluralize(this.institution.navigationNodeLevelNames[0]),
          link: false
        })
      }

      institution.navigationNodes.items.forEach(async nn => {

        if (nn.parentConnection == null && nn.active && (this.currentUser.isPresenter || nn.visible == null || nn.visible)) {

          var childNodeCount = nn.childConnections.items.filter(cc => cc.child.active && (this.currentUser.isPresenter || cc.child.visible == null || cc.child.visible)).length 
          var childModuleCount = nn.modules.items.filter(m => m.active && (this.currentUser.isPresenter || m.visible == null || m.visible)).length

          var navigationNode = {
            id: nn.id,
            description: nn.description,
            image: nn.image ? environment.cloudfrontUrl + nn.image : null,
            label: nn.label,
            order: nn.order,
            childCount: childNodeCount + childModuleCount,
            visible: nn.visible == null || nn.visible
          }

          this.navigationNodes.push(navigationNode)

        }

      })

      this.sortNavigationNodesByOrder();

      this.loading = false;

    })

  }

  sortNavigationNodesByLabel() : void {
    this.navigationNodes = this.navigationNodes.sort(sortByLabel);
  }

  sortNavigationNodesByOrder() : void {
    this.navigationNodes = this.navigationNodes.sort(sortByOrder)
  }

  sortModulesByLabel() : void {
    this.modules = this.modules.sort(sortByLabel);
  }

  sortModulesByOrder() : void {
    this.modules = this.modules.sort(sortByOrder)
  }

  handleNavigationNodeClick(navigationNodeId) : void {
    this.router.navigate(["home", navigationNodeId])
  }

  playModule(moduleId) : void {
    if (this.currentUser.isPresenter) {
      this.router.navigate(["module", moduleId])
    }
  }

  addNode() : void {
    var commands = ["nodeAdd", this.institution.id]
    if (this.navigationNodeId != null) commands.push(this.navigationNodeId)
    this.router.navigate(commands)
  }

  addModule() : void {
    this.router.navigate(["moduleAdd", this.institution.id, this.navigationNodeId])
  }

  editModule(moduleId) : void {
    this.router.navigate(["moduleEdit", moduleId])
  }

  deleteModule(moduleId) : void {
    if (!confirm('Confirm Delete')) return
    this.loading = true;
    this.api.UpdateModule({
      id: moduleId,
      active: false
    }).then(r => {
      this.reload();
    })
    
  }

  deleteNode(event: Event, nodeId) : void {
    event.stopPropagation();
    if (!confirm('Confirm Delete')) return;
    this.loading = true;
    this.api.UpdateNavigationNode({
      id: nodeId,
      active: false
    }).then(r => {
      this.reload();
    })
  }

  editNode(event: Event, nodeId): void {
    event.stopPropagation();
    this.router.navigate(["nodeEdit", nodeId])
  }

  moduleResponses(moduleId) {
    this.router.navigate(["moduleResponses", moduleId])
  }

  toggleNodeVisibility(event: Event, node) {
    event.stopPropagation();
    node.loadingVisibility = true
    this.api.UpdateNavigationNode({
      id: node.id,
      visible: !node.visible
    }).then(n => {
      node.visible = n.visible;
      node.loadingVisibility = false; 
    }).catch(e => {
      node.loadingVisibility = false; 
    })
  } 

  toggleModuleVisibility(module) {
    module.loadingVisibility = true
    this.api.UpdateModule({
      id: module.id,
      visible: !module.visible
    }).then(m => {
      module.visible = m.visible;
      module.loadingVisibility = false; 
    }).catch(e => {
      module.loadingVisibility = false; 
    })
  }

  toggleModulePublic(module) {
    module.loadingPublic = true;
    this.api.UpdateModule({
      id: module.id,
      public: !module.public
    }).then(m => {
      module.public = m.public;
      module.loadingPublic = false; 
    }).catch(e => {
      module.loadingPublic = false; 
    })
  }

  copyLinkModule(module) {

    var path = this.location.prepareExternalUrl(`module/s/${module.id}`)
    var url = `${document.location.origin}${path}`

    copyToClipboard(url)

    this._snackbar.open('Link Copied to Clipboard', null, {
      duration: 1000
    })

  }

  onNodeSortChange(event) {
    this.loadingNavigationNodes = true;
    this.api.SetNavigationNodesOrder(this.navigationNodes.map(nn => nn.id)).then(success => {
      if (!success) {
        this.reload()
      } else {
        this.loadingNavigationNodes = false;
      }
    }).catch(e => { this.reload() })
  }

  onModuleSortChange(event) {
    this.loadingModules = true;
    this.api.SetModulesOrder(this.modules.map(m => m.id)).then(success => {
      if (!success) {
        this.reload();
      } else {
        this.loadingModules = false;
      }
    }).catch(e => { this.reload() })
  }

  ngOnDestroy(){
    if (this.authSub){
      this.authSub.unsubscribe()
    }
    if (this.routeSub){
      this.routeSub.unsubscribe()
    }
  }

}
